module.exports = __webpack_public_path__ + "static/media/ic_list_arrow_nor.4b6df309.svg";